"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityDisplay = void 0;
var _fileExtensionMapping = require("../../utils/data/fileExtensionMapping");
var _getFileExtension = require("../../utils/data/getFileExtension");
var _nirvanaDoctypeIcon = _interopRequireDefault(require("@adsk/nirvana-doctype-icon"));
var _alloyReactButton = require("@adsk/alloy-react-button");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PlacementDeleteModal = require("../../IssueDetailPanel/IssueDetailTabPanel/detail-panel-fields/PlacementDeleteModal");
var _templateObject, _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const EntityDisplayContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  background-color: ", ";\n"])), _alloyReactTheme.default.colors.charcoal400, props => !!props.error ? _alloyReactTheme.default.colors.red300 : "transparent");
const DisplayNameContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"])));
const EntityIconAndName = _ref => {
  let {
    entityType,
    entity
  } = _ref;
  switch (entityType) {
    case "files":
      {
        const fileName = entity.fileName;
        const fileTypeIcon = _fileExtensionMapping.FILE_EXTENSION_MAPPING[(0, _getFileExtension.getFileExtension)(fileName)];
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            paddingRight: 8
          }
        }, /*#__PURE__*/_react.default.createElement(_nirvanaDoctypeIcon.default, {
          type: fileTypeIcon,
          size: 22
        })), /*#__PURE__*/_react.default.createElement(DisplayNameContainer, null, fileName));
      }
    case "sheets":
      {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            paddingRight: 8,
            marginTop: 2
          }
        }, /*#__PURE__*/_react.default.createElement(_alloyReactIcon.SheetsIcon, {
          size: 22
        })), /*#__PURE__*/_react.default.createElement(DisplayNameContainer, null, entity.name));
      }
    default:
      return null;
  }
};
const EntityDisplay = _ref2 => {
  let {
    entityType,
    entity,
    onRemove,
    error
  } = _ref2;
  const [isPlacementDeleteModalOpen, setIsPlacementDeleteModalOpen] = (0, _react.useState)(false);
  const handleButtonClick = (0, _react.useCallback)(() => {
    setIsPlacementDeleteModalOpen(true);
  }, [setIsPlacementDeleteModalOpen]);
  const handleModalClose = (0, _react.useCallback)(() => {
    setIsPlacementDeleteModalOpen(false);
  }, [setIsPlacementDeleteModalOpen]);
  if (!entityType || !entity) {
    return null;
  }
  const isFile = entityType == "files";
  const isSheet = entityType == "sheets";
  const placementText = isFile ? entity.fileName : isSheet ? entity.name : undefined;
  return /*#__PURE__*/_react.default.createElement(EntityDisplayContainer, {
    error: error
  }, /*#__PURE__*/_react.default.createElement(EntityIconAndName, {
    entityType: entityType,
    entity: entity
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, error && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginRight: "16px",
      marginTop: "4px"
    }
  }, /*#__PURE__*/_react.default.createElement(_alloyReactIcon.AlertWarningFilledIcon, {
    color: _alloyReactTheme.default.colors.red500,
    size: 20
  })), /*#__PURE__*/_react.default.createElement(_alloyReactButton.IconButton, {
    renderIcon: p => /*#__PURE__*/_react.default.createElement(_alloyReactIcon.XIcon, p),
    type: "button",
    size: 24,
    onClick: handleButtonClick
  })), /*#__PURE__*/_react.default.createElement(_PlacementDeleteModal.PlacementDeleteModal, {
    isOpen: isPlacementDeleteModalOpen,
    placementText: placementText,
    isFile: isFile,
    onDelete: onRemove,
    onClose: handleModalClose
  }));
};
exports.EntityDisplay = EntityDisplay;
//# sourceMappingURL=EntityDisplay.js.map